<template>
  <div>
    <!-- =============== START OF FOOTER =============== -->
    <footer class="footer1 bg-dark">
      <!-- ===== START OF FOOTER WIDGET AREA ===== -->
      <div class="footer-widget-area ptb100">
        <div class="container">
          <div class="row">
            <!-- Start of Widget 1 -->
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="widget widget-about">
                <!-- INSERT YOUR LOGO HERE -->
                <img src="../assets/images/logo.svg" alt="logo" class="logo" />
                <!-- INSERT YOUR WHITE LOGO HERE -->
                <img
                  src="../assets/images/logo-white.svg"
                  alt="white logo"
                  class="logo-white"
                />
                <p class="nomargin">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Itaque, ducimus, atque. Praesentium suscipit provident
                  explicabo dignissimos nostrum numquam deserunt earum
                  accusantium et fugit.
                </p>
              </div>
            </div>
            <!-- End of Widget 1 -->

            <!-- Start of Widget 2 -->
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="widget widget-links">
                <h4 class="widget-title">Useful links</h4>

                <ul class="general-listing">
                  <li><a href="#">about movify</a></li>
                  <li><a href="#">blog</a></li>
                  <li><a href="#">forum</a></li>
                  <li><a href="#">my account</a></li>
                  <li><a href="#">watch list</a></li>
                </ul>
              </div>
            </div>
            <!-- End of Widget 2 -->

            <!-- Start of Widget 3 -->
            <!-- <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="widget widget-blog">
                <h4 class="widget-title">latest news</h4>

                <ul class="blog-posts">
                  <li>
                    <a href="#">blog post 1</a><small>januar 13, 2018</small>
                  </li>
                  <li>
                    <a href="#">blog post 2</a><small>januar 13, 2018</small>
                  </li>
                  <li>
                    <a href="#">blog post 3</a><small>januar 13, 2018</small>
                  </li>
                </ul>
              </div>
            </div> -->
            <!-- End of Widget 3 -->

            <!-- Start of Widget 4 -->
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="widget widget-social">
                <h4 class="widget-title">follow us</h4>

                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Itaque, ducimus, atque.
                </p>

                <!-- Start of Social Buttons -->
                <ul class="social-btns">
                  <!-- Social Media -->
                  <li>
                    <a href="#" class="social-btn-roll facebook">
                      <div class="social-btn-roll-icons">
                        <i class="social-btn-roll-icon fa fa-facebook"></i>
                        <i class="social-btn-roll-icon fa fa-facebook"></i>
                      </div>
                    </a>
                  </li>

                  <!-- Social Media -->
                  <li>
                    <a href="#" class="social-btn-roll twitter">
                      <div class="social-btn-roll-icons">
                        <i class="social-btn-roll-icon fa fa-twitter"></i>
                        <i class="social-btn-roll-icon fa fa-twitter"></i>
                      </div>
                    </a>
                  </li>

                  <!-- Social Media -->
                  <li>
                    <a href="#" class="social-btn-roll google-plus">
                      <div class="social-btn-roll-icons">
                        <i class="social-btn-roll-icon fa fa-google-plus"></i>
                        <i class="social-btn-roll-icon fa fa-google-plus"></i>
                      </div>
                    </a>
                  </li>

                  <!-- Social Media -->
                  <li>
                    <a href="#" class="social-btn-roll instagram">
                      <div class="social-btn-roll-icons">
                        <i class="social-btn-roll-icon fa fa-instagram"></i>
                        <i class="social-btn-roll-icon fa fa-instagram"></i>
                      </div>
                    </a>
                  </li>
                </ul>
                <!-- End of Social Buttons -->
              </div>
            </div>
            <!-- End of Widget 4 -->
          </div>
        </div>
      </div>
      <!-- ===== END OF FOOTER WIDGET AREA ===== -->

      <!-- ===== START OF FOOTER COPYRIGHT AREA ===== -->
      <div class="footer-copyright-area ptb30">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="d-flex">
                <div class="links">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <a href="#">Privacy & Cookies</a>
                    </li>
                    <li class="list-inline-item">
                      <a href="#">Terms & Conditions</a>
                    </li>
                    <li class="list-inline-item">
                      <a href="#">Legal Disclaimer</a>
                    </li>
                    <li class="list-inline-item">
                      <a href="#">Community</a>
                    </li>
                  </ul>
                </div>

                <div class="copyright ml-auto">
                  All Rights Reserved by <a href="#">Movify</a>.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ===== END OF FOOTER COPYRIGHT AREA ===== -->
    </footer>
    <!-- =============== END OF FOOTER =============== -->
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
